import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import getIconsByCategoryAction from "../actions/get-icons-by-category.actions";
import { customerPortal } from "@vilocnv/allsetra-core";

type IconState = customerPortal.icons.IconState;

const getIconsByCategoryCases = (
  builder: ActionReducerMapBuilder<IconState>
) => {
  builder.addCase(getIconsByCategoryAction.pending, (state, action) => {
    state.isLoadingIconsByCategory = true;
  });
  builder.addCase(getIconsByCategoryAction.fulfilled, (state, action) => {
    state.iconsByCategory = action.payload || [];
    state.isLoadingIconsByCategory = false;
  });
  builder.addCase(getIconsByCategoryAction.rejected, (state) => {
    state.isLoadingIconsByCategory = false;
  });
};

export default getIconsByCategoryCases;
